import {useMemo} from 'react'
import {useGetCurrentUserQuery, useGetStructuresQuery} from 'store/Store'
import {getDocumentId} from 'utils'

const useFormConsumerLogic = ({fields, methods}) => {
    const {data: user} = useGetCurrentUserQuery()
    const userAccount = useMemo(() => user?.account, [user])
    const {watch} = methods
    const {account} = watch()
    const {data: structures, isLoading: isLoadingStructure} = useGetStructuresQuery(
        {account: getDocumentId(account)},
        {skip: !userAccount && !account}
    )

    fields.createConsumer.items.structure.options = structures?.data
    fields.createConsumer.items.structure.isLoading = isLoadingStructure

    return {fields}
}

export default useFormConsumerLogic
